import * as Types from '../../../../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SearchInventoryItemsQueryVariables = Types.Exact<{
  name?: Types.InputMaybe<Types.Scalars['String']>;
  pageSize: Types.Scalars['Int'];
  pageNumber: Types.Scalars['Int'];
  facilityId: Types.Scalars['String'];
  orderBy: Types.InventorySearchOrderProperty;
}>;


export type SearchInventoryItemsQuery = { readonly __typename?: 'Query', readonly inventorySearchTmp: { readonly __typename?: 'InventorySummaryConnection', readonly totalCount?: number | null, readonly edges: ReadonlyArray<{ readonly __typename?: 'InventorySummaryEdge', readonly node: { readonly __typename?: 'InventorySummary', readonly supplyLevel?: Types.SupplyLevel | null, readonly facilityQuantity?: number | null, readonly sku: { readonly __typename?: 'Sku', readonly id: string, readonly name: string } } }> } };


export const SearchInventoryItemsDocument = gql`
    query searchInventoryItems($name: String, $pageSize: Int!, $pageNumber: Int!, $facilityId: String!, $orderBy: InventorySearchOrderProperty!) {
  inventorySearchTmp(
    input: {name: $name, facilityId: $facilityId}
    options: {pageSize: $pageSize, pageNumber: $pageNumber, order: {by: $orderBy}}
  ) {
    totalCount
    edges {
      node {
        sku {
          id
          name
        }
        supplyLevel
        facilityQuantity
      }
    }
  }
}
    `;

/**
 * __useSearchInventoryItemsQuery__
 *
 * To run a query within a React component, call `useSearchInventoryItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchInventoryItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchInventoryItemsQuery({
 *   variables: {
 *      name: // value for 'name'
 *      pageSize: // value for 'pageSize'
 *      pageNumber: // value for 'pageNumber'
 *      facilityId: // value for 'facilityId'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useSearchInventoryItemsQuery(baseOptions: Apollo.QueryHookOptions<SearchInventoryItemsQuery, SearchInventoryItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchInventoryItemsQuery, SearchInventoryItemsQueryVariables>(SearchInventoryItemsDocument, options);
      }
export function useSearchInventoryItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchInventoryItemsQuery, SearchInventoryItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchInventoryItemsQuery, SearchInventoryItemsQueryVariables>(SearchInventoryItemsDocument, options);
        }
export type SearchInventoryItemsQueryHookResult = ReturnType<typeof useSearchInventoryItemsQuery>;
export type SearchInventoryItemsLazyQueryHookResult = ReturnType<typeof useSearchInventoryItemsLazyQuery>;
export type SearchInventoryItemsQueryResult = Apollo.QueryResult<SearchInventoryItemsQuery, SearchInventoryItemsQueryVariables>;